<template>
  <div class="services-provided-page">
    <div class="page-header">
      <h1>Świadczone usługi</h1>
      <button class="btn-primary" @click="$router.push('/dla-biznesu/profile/services-provided/add')">+ Dodaj usługę</button>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Wyszukiwanie usług</h2>
      </div>

      <div class="search-container">
        <input
            type="text"
            class="search-input"
            id="serviceSearch"
            v-model="serviceSearch"
            placeholder="Szukaj usług..."
            @keyup.enter="searchService"
        >
        <button @click="searchService" class="btn-green">Szukaj</button>
        <button
            @click="() => {
            getMyServices()
            serviceSearch = ''
          }"
            class="btn-outline"
        >
          Resetuj
        </button>
      </div>
    </div>

    <div class="section-card position-relative">
      <HintComponent page-key="business_panel_services_list" :absolute="true" />
      <div class="section-card-header">
        <h2>Lista usług</h2>
      </div>

      <div v-if="currentUser && myServices.length > 0" class="services-grid">
        <div v-if="states.length > 0" class="cards-wrap">
          <ServiceCardVue
            v-for="service in myServices"
            :key="service.service.id"
            :price="service.service.price"
            :is-advance="!!service.service.advanceAmount"
            :id="service.service.id"
            :img="service.service.photo_url"
            :name="service.service.name"
            :state="states.filter(state => state.value == service.service.state_id)[0].name"
            :ishighlighted="service.service.active"
            :editable="true"
            :userServiceId="service.id"
            :should-show-action-button="false"
            @editService="(id) => { $router.push({ path: `/dla-biznesu/profile/services-provided/edit`, query: { serviceToEdit: id } }) }"
            @deleteService="(id, userServiceId) => deleteService(id, userServiceId)"
            @openServiceModal="() => $router.push({ path: `/dla-biznesu/profile/services-provided`, query: { serviceID: service.service.id } })"
          />
        </div>
        <div v-else class="empty-state">
          <p>Ładowanie...</p>
        </div>
      </div>

      <div v-else class="empty-state">
        <p>Brak usług.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useMeta } from 'vue-meta';
import ServiceCardVue from '@/components/SpecialComponents/ServiceCard.vue';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
import HintComponent from "@/components/SpecialComponents/HintComponent.vue";

export default {
  name: 'BizProfileServicesProvided',
  setup() {
    useMeta({ title: 'Świadczone usługi' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      myServices: [],
      states: [],
      serviceSearch: '',
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  components: {
    HintComponent,
    ServiceCardVue
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 2) {
      this.$router.push('/login');
    }

    if (this.appStore.isSubscribed) {
      this.getMyServices();
    } else {
      this.$router.push('/dla-biznesu/profile/user-data');
    }
  },
  methods: {
    getMyServices() {
      axios.get(`/UserService/${this.currentUser.id}`).then(res => {
        this.myServices = res.data;
      });

      axios.get('/State').then(res => {
        this.states = [];
        res.data.forEach((item) => {
          const ob = {
            name: item.name,
            value: `${item.id}`,
          };
          this.states.push(ob);
        });
      });
    },
    deleteService(id, userServiceId) {
      axios.delete(`/Service/${id}`, authHeader()).then(res => {
        if (String(res.status).charAt(0) == '2') {
          axios.delete(`/UserService/${userServiceId}`, authHeader()).then(resp => {
            if (String(resp.status).charAt(0) == '2') {
              this.appStore.setIsSuccess('Pomyślnie usunięto usługę');
              this.getMyServices();
            }
          });
        }
      });
    },
    searchService() {
      if (this.serviceSearch.length > 2) {
        this.myServices = this.myServices.filter(item => item.service.name.toLowerCase().includes(this.serviceSearch.toLowerCase()));
      } else {
        this.appStore.setIsAlert('wpisz co najmniej 3 znaki');
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.services-provided-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  color: #1f2937;
  font-weight: 700;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .08);
  padding: 24px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.section-card-header {
  margin-bottom: 14px;
}

.section-card-header h2 {
  margin: 0;
  font-size: 2rem;
  color: #1f2937;
  font-weight: 700;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.search-input {
  border: 1px solid #d1d5db;
  padding: 10px 12px;
  border-radius: 8px;
  min-width: 240px;
  font-size: 1.4rem;
  outline: none;
}

.search-input:focus {
  border-color: #10b981;
}

.services-grid {
  margin-top: 8px;
}

.cards-wrap {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 18px;
}

@media (max-width: 1024px) {
  .cards-wrap {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 720px) {
  .cards-wrap {
    grid-template-columns: 1fr;
  }
}

.empty-state {
  text-align: center;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  padding: 24px;
  color: #9ca3af;
  font-size: 1.5rem;
}

.btn-primary {
  background: #f97316;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
}

.btn-primary:hover {
  background: #ea6c0a;
}

.btn-green {
  background: #10b981;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
}

.btn-green:hover {
  background: #059669;
}

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 1.4rem;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

@media (max-width: 480px) {
  .services-provided-page {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card-header h2 {
    font-size: 1.8rem;
  }

  .search-input,
  .btn-primary,
  .btn-green,
  .btn-outline {
    width: 100%;
  }
}
</style>